import { useEffect, useState } from "react";
import { ItineraryIntroPDF } from "./ItineraryIntroPDF.tsx";
import { ItineraryDaysPDF } from "./ItineraryDaysPDF.tsx";
import { ItineraryDetailsPDF } from "./ItineraryDetailsPDF.tsx";
import { ItineraryHotelsPDF } from "./ItineraryHotelsPDF.tsx";
import { processFonts } from "../utils.tsx";
import React from "react";
import {useParams} from "react-router-dom";
import {TourCatalog, TourOperator} from "../contentfulModel.ts";
import {ItineraryPricingPDF} from "./ItineraryPricingPDF.tsx";

const ENV = import.meta.env.VITE_ENV_NAME || 'dev';

const storagePath = ENV === "dev" ? 'assets/tourCatalogs/' : 'tourCatalogs/';


export const ItineraryCatalogPDFView = () => {
    const [tourCatalog, setTourCatalog] = useState<TourCatalog | null>(null);
    const [tourOperator, setTourOperator] = useState<TourOperator | null>(null);
    const [catalogName, setCatalogName] = useState<string>("");
    const [error, setError] = useState<string | null>(null);
    const params = useParams()


    useEffect(() => {
        //add to html header
        //
        // @page {
        //     size: 286mm 216mm;
        //     margin: 3mm;
        //   }
        //
        //   html, body {
        //     margin: 0;
        //     padding: 0;
        //   }
        //
        //
        //   @prince-pdf {
        //     prince-pdf-output-intent: url("https://storage.googleapis.com/tripsapp-prod-cdn/printing/GRACoL2006_Coated1v2.icc?alt=media");
        //   }
        //   @prince-pdf {
        //     prince-fallback-cmyk-profile: url("https://storage.googleapis.com/tripsapp-prod-cdn/printing/GRACoL2006_Coated1v2.icc?alt=media");
        //   }

        window.document.head.insertAdjacentHTML("beforeend", `
        <style>
        @page {
            size: 420mm 297mm;
            margin: 0mm;
          }
        
          html, body {
            margin: 0;
            padding: 0;
          }

          @prince-pdf {
            prince-pdf-output-intent: url("https://storage.googleapis.com/tripsapp-prod-cdn/printing/GRACoL2006_Coated1v2.icc?alt=media");
          }
          @prince-pdf {
            prince-fallback-cmyk-profile: url("https://storage.googleapis.com/tripsapp-prod-cdn/printing/GRACoL2006_Coated1v2.icc?alt=media");
          }
        </style>
        `);



    }, []);

    useEffect(() => {
        async function fetchTourOperator() {
            // For now using hardcoded values instead of URL paths
            const operatorName = params.tourOperator
            const catalogNameValue = params.catalog

            // First letter to uppercase
            const formattedOperatorName = operatorName.charAt(0).toUpperCase() + operatorName.slice(1);

            if (!formattedOperatorName || !catalogNameValue) {
                setError("No tour operator specified");
                return;
            }

            try {
                const timestamp = new Date().getTime();
                const catalogUrl = `https://storage.googleapis.com/tripsapp-${ENV}-cdn/${storagePath}${operatorName.toLowerCase()}/catalogs.json?t=${timestamp}`;
                const configUrl = `https://storage.googleapis.com/tripsapp-${ENV}-cdn/${storagePath}${operatorName.toLowerCase()}/config.json?t=${timestamp}`;

                // Use fetch with cache: 'no-store' to bypass the cache
                const [catalogResponse, configResponse] = await Promise.all([fetch(catalogUrl), fetch(configUrl)]);
                if (!catalogResponse.ok || !configResponse.ok) {
                    throw new Error(`HTTP error! status: ${catalogResponse.status} ${configResponse.status}`);
                }
                const tourCatalogs: TourCatalog[] = await catalogResponse.json();
                const tourOperatorConfig: TourOperator = await configResponse.json();

                if (tourOperatorConfig && tourCatalogs) {
                    setTourOperator(tourOperatorConfig);
                    // Only process fonts if we have data
                    processFonts(tourOperatorConfig);
                    setCatalogName(catalogNameValue.toLowerCase());


                    if (tourCatalogs) {
                        const foundCatalog = tourCatalogs.find(
                            (catalog) => catalog.name.toLowerCase() === catalogNameValue.toLowerCase()
                        );
                        if(params.itinerary){
                            //remove other packages
                            const filteredPackages = foundCatalog?.tourPackages.filter(
                                (pkg) => pkg.name.toLowerCase() === params.itinerary?.toLowerCase()
                            );
                            foundCatalog.tourPackages = filteredPackages || [];
                        }
                        setTourCatalog(foundCatalog || null);
                    }
                }
            } catch (error) {
                console.error("Error fetching TourOperator data:", error);
                setError("Error fetching data");
            }
        }

        fetchTourOperator();
    }, []);


    if (error) {
        return (
            <div className="w-full h-full flex items-center justify-center">
                <p className="text-lg text-red-500">{error}</p>
            </div>
        );
    }

    if (!tourCatalog || !tourOperator) {
        return (
            <div className="w-full h-full flex items-center justify-center">
                <p className="text-lg text-gray-500">Loading...</p>
            </div>
        );
    }

    // Make sure tourPackages exists and has elements
    const tourPackages = tourCatalog.tourPackages;
    if (!tourPackages || tourPackages.length === 0) {
        return (
            <div className="w-full h-full flex items-center justify-center">
                <p className="text-lg text-red-500">No tour package found</p>
            </div>
        );
    }



    return (
        <>

            {tourPackages.map((tourPackage, index) => (
                <React.Fragment key={`package-${index}`}>
                    {/* Each tour package gets its own set of pages */}
                    <div className="pdf-page intro-page">
                        <ItineraryIntroPDF
                            tourPackage={tourPackage}
                            tourOperator={tourOperator}
                        />
                    </div>

                    <div className="pdf-page days-page">
                        <ItineraryDaysPDF
                            tourPackage={tourPackage}
                            tourOperator={tourOperator}
                        />
                    </div>

                    <div className="pdf-page details-page">
                        <ItineraryDetailsPDF
                            tourPackage={tourPackage}
                            tourOperator={tourOperator}
                            tourCatalog={tourCatalog}
                        />
                    </div>
                    <div className="pdf-page details-page">
                        <ItineraryHotelsPDF
                            tourPackage={tourPackage}
                            tourOperator={tourOperator}
                            tourCatalog={tourCatalog}
                        />
                    </div>
                    <div className="pdf-page details-page">
                        <ItineraryPricingPDF
                            tourPackage={tourPackage}
                            tourOperator={tourOperator}
                        />
                    </div>
                </React.Fragment>
            ))}

            <style>{`
            
         @page {
    size: 42cm 29.71cm;
    margin: 0;
  }
  #root {
  margin: 0;
    padding: 0;
    overflow: visible !important;
    height: auto !important;
  }

    html, body {
      margin: 0;
      padding: 0;
      width: 42cm;
      overflow: visible !important;
      background: white;
    }
    .pdf-page {
      /* height y overflow eliminados del wrapper */
      box-sizing: border-box;

      /* permitir división */
      break-inside: auto !important;
      page-break-inside: auto !important;
    }
    
  .intro-page,.days-page,.details-page {
    /* tamaño exacto de la hoja A3 landscape */
    min-height: 29.71cm;
    width: 42cm;

    /* ocultar todo lo que se desborde */
    overflow: hidden !important;

    /* evitar que se divida o que genere páginas nuevas */
    page-break-inside: avoid !important;
    break-inside: avoid-column !important;
    page-break-after: auto !important;
    break-after: auto !important;

    /* si quieres, asegúrate de que empiece siempre tras la Intro */
    page-break-before: always;
    break-before: always;
  }
    
    /* saltos sólo antes de estos bloques */
    .intro-page {
      page-break-before: auto;
    }
    
    .rich-text p {
    font-size: 12px !important;
    line-height: calc(1 / 0.75) !important;
    font-weight: 300 !important;
    }
    .rich-text li {
    margin-bottom: 0.3em !important;
    gap: 0.3em !important;
    }
   
            `}</style>
        </>
    );
};
